import React from 'react';
import { observer } from 'mobx-react';
import { Route } from 'react-router-dom';

import List from './List';
import ListMedia from './ListMedia';
import EditJournalist from './EditJournalist';

@observer
export default class Media extends React.Component {
	render() {
		const rootPath = '/admin/media-accreditation';

		return (
			<div>
				<Route
					exact
					path={`${rootPath}/mediatitles`}
					rootPath={rootPath}
					component={() => <List rootPath={rootPath} tabName="media" />}
				/>

				<Route
					exact
					path={`${rootPath}/mediatitles/:id`}
					rootPath={rootPath}
					component={() => <ListMedia rootPath={rootPath} tabName="media" />}
				/>

				<Route
					exact
					path={`${rootPath}/mediatitles/:id/mediajournalists`}
					rootPath={rootPath}
					component={() => <ListMedia rootPath={rootPath} tabName="media" />}
				/>
				<Route
					exact
					path={`${rootPath}/mediatitles/:id/mediajournalists/:jid`}
					rootPath={`${rootPath}/mediatitles/:id`}
					component={() => <EditJournalist rootPath={rootPath} tabName="media" />}
				/>
			</div>
		);
	}
}
